import React from "react";
import styled from "styled-components";
import Column from "./Column"

const StyledBarGraph = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 375px;
  background-color: white;
  margin: 2em auto;
  display: flex;
`;

const BarGraph = ({ data, handleIndexChange, selected, ...props }) => (
    <StyledBarGraph {...props}>
      {data.map((column, index) => (
        <Column 
          key={index} 
          data={data} 
          column={column} 
          index={index} 
          handleIndexChange={handleIndexChange} 
          selected={typeof selected === "number" ? selected === index : index === data.length - 1}
        />
      ))}
    </StyledBarGraph>
  );

export default BarGraph;


// WEBPACK FOOTER //
// ./src/artzu-ui/src/BarGraph/index.js